












































































import {
  Component,
  Vue
} from "vue-property-decorator";
@Component
export default class WelcomePopUp extends Vue {
  private isVisible = true;
}
